var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../../actions/betting-history/bettingHistory';
import * as loadingState from '../../constants/loading';
var initialState = {
    loadingState: loadingState.INIT,
    data: []
};
export default function bettingHistoryReducer(state, action) {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case Actions.FETCH_BETTING_HISTORY:
            return __assign(__assign({}, state), { loadingState: loadingState.FETCHING });
        case Actions.SUCCESS_FETCH_BETTING_HISTORY:
            return __assign(__assign({}, state), { loadingState: loadingState.FETCHED, data: action.data || [] });
        case Actions.FAILURE_FETCH_BETTING_HISTORY:
            return __assign(__assign({}, state), { loadingState: loadingState.FETCHED });
        case Actions.CLEAR_BET_HISTORY:
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/betting-history/bettingHistoryReducer.js